import { useState, useEffect } from 'react';

import Loading from "../../components/Loading";
import Item from './components/Item';
import Data from '../../../repository';

import styles from '../../../styles/Admin.module.scss';

function List() {
    const [loading, setLoading] = useState(true);
    let [users, setUsers] = useState([]);
    const [search, setSearch] = useState('');

    useEffect(async () => {
        await refreshUsers();
    }, []);

    const refreshUsers = async () => {
        setLoading(true);
        const result = await Data.fetchUsers();
        setUsers(result.data);
        setLoading(false);
    }

    const exportCsv = async () => {
        const response = await Data.exportMembers();
        const blob = new Blob([response.data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'members.csv');
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
    }

    if (loading) return <Loading button={false} />;

    users = users.filter((user) => {
        const query = `${user.firstName} ${user.lastName} (${user.email})`;
        return query.toLowerCase().includes(search.toLowerCase());
    });

    return (
        <div className={styles.list}>
            <input
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search by name or email..."
            />
            <button onClick={exportCsv} className={styles.button}>Export Members</button>

            {!users.length && <div><p>There aren't any members to show.</p></div>}

            {!!users.length && (
                <div className={styles.tableWrap}>
                    <table className={styles.table}>
                        <thead>
                            <tr>
                                <th>Member</th>
                                <th>Plan</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {users.map((user) => (
                                <Item key={user._id} {...user} />
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

export default List;
